<template>
  <div class="app-tutorial-module">
    <ModuleBaseHeader :decoration="false" :title="title" />
    <div class="mt-2 grid grid-cols-3 gap-4">
      <BaseCard
        v-for="item in filterUrlIsEmpty(list)"
        :key="item.id"
        :title="item.title"
        :image="item.image || ''"
        :url="`${prefixPath}/${item.url}`"
        :ratio="16.5 / 9"
        custom-info
      >
        <div class="flex items-center bg-[#1b1b1b] px-2.5 py-1">
          <h3 class="capitalize truncate text-xl ...">{{ item.title }}</h3>
        </div>
      </BaseCard>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { CatalogsConfig } from '~/components/gfr/types/components'
defineProps({
  title: {
    type: String,
    default: ''
  },
  list: {
    type: Array as PropType<CatalogsConfig[]>,
    default: () => []
  },
  prefixPath: {
    type: String,
    default: ''
  }
})
const filterUrlIsEmpty = (catalogs: CatalogsConfig[]) => {
  return catalogs.filter((item) => {
    return item.url !== ''
  })
}
</script>
